import React from 'react'
import messages from '../../../locales/es-ec/messages'
import IndexPage from '../index'
import { isToggleActive, isFeatureActiveByCountry } from '../../utils/feature-toggle'

export default props => (
  <div className={isToggleActive('ELO_EC') ? 'elo-EC' : null}>
    <IndexPage langKey="es_EC" isEloThemeActive={isToggleActive('ELO_EC')} isChartNoProductActive={isFeatureActiveByCountry('CHART_NO_PRODUCTS', 'EC')}  i18nMessages={messages} {...props} />
  </div>
)
